import PreventionCategory_Minimal from './PreventionCategory_Minimal'

export default {
    PreventionCategory_Minimal,
}
